import React, { Component } from 'react';

class ByteBeatEngine {
    constructor() {
        this.playing = false;
        this.current_sample = 0;
        this.sample_rate = 0;
        this.current_time = 0;
        this.current_second = 0;
        this.sound = null;
        this.all_vizsquares = []
        this.bytebeat = null;
        this.all_bytebeats = [];
        this.current_second_offset = 0;
        this.setupAudio();
    }

    // Playpause function for starting, pausing, restarting audio
    playpause(){
        if(this.playing){
            // pause
            this.playing = false;
            //document.getElementById("play").innerHTML = "play";
            return; 
        }else{
            if(this.sound){
                this.sound.resume();
            }
            this.playing = true;
            //document.getElementById("play").innerHTML = "pause";
        }
    }

    skip_to(seconds){
        this.current_second = seconds;
        this.current_sample = seconds * this.bytebeat.data.sr;
        this.current_time = seconds * this.sound.sampleRate 
    }

    get_seconds(){
        if(this.playing){
            return this.current_second - this.current_second_offset + this.sound.currentTime;
        }else{
            return this.current_second;
        }
    }
    get_sample_index(){
        return Math.floor(this.get_seconds() * this.bytebeat.data.sr);
    }

    // run once to setup sound
    setupAudio(){
        this.playing = false; // audio is playing 

        // AUDIO
        let sound = new (window.AudioContext || window.webkitAudioContext)({sampleRate:44100});
        this.sound = sound;
        console.log("hh")
        
        var buffer_size = 1024/2;
        var buffer = sound.createBuffer(1, buffer_size, sound.sampleRate);
        var buffer_node = sound.createBufferSource();
        var script_node = sound.createScriptProcessor(buffer_size, 1, 1);

        // soften volume
        var gain_node = sound.createGain();
        gain_node.gain.setValueAtTime(0.25, sound.currentTime);

        // connect
        buffer_node.connect(script_node);
        script_node.connect(gain_node); 
        gain_node.connect(sound.destination);
        
        buffer_node.loop = true;
        buffer_node.start();
        
        // Every buffer_size samples (@44.1k) we call this function, generate audio, and write samples to output buffer
        script_node.onaudioprocess = function(event){
            var channel = 0; 
            var output = event.outputBuffer.getChannelData(channel);
            var last_t = -1;
            var amplitude = 0;
            this.draw()
            for(var i=0; i<output.length; i++){
                // Resampling: The bytebeat is at a different sample rate from the sound card:
                // This is the t which is fed into the bytebeat function
                if(!this.playing || !this.bytebeat){
                    output[i] = 0;
                }else{
                    var t = Math.floor( this.bytebeat.data.sr * this.current_time / sound.sampleRate );
                    this.current_sample = t;
                    this.current_second = t/this.bytebeat.data.sr;
                    this.current_second_offset = sound.currentTime;
                    if(last_t != t){
                        // we have moved forward one time step in the bytebeat, calculate the new value
                        amplitude = this.bytebeat.data.f(t);              
                        // convert to 8 bit quantization
                        amplitude &= 255;
                        // convert to float between -1 to 1
                        amplitude = (amplitude-128)/256;                                      
                    }
                    // Write the amplitude to the output buffer
                    output[i] = amplitude;
                    last_t = t;
                    this.current_time++;
                }
            }
        }.bind(this)
    }
    // this draws all the bytebeats 
    draw(){
        if(this.playing){
            /*for(var i=0;i<this.all_vizsquares.length;i++){
                this.all_vizsquares[i].draw(this.current_sample)
            }*/
            if(this.bytebeat && this.bytebeat.viz_square){

            //console.log(this.bytebeat.viz_square)
                this.bytebeat.viz_square.draw(this.current_sample)
            }
        }
    }

    change_bytebeat(bytebeat){
        this.bytebeat = bytebeat;
        this.bytebeat.viz_square.canvas.width = this.bytebeat.viz_square.size
        this.bytebeat.viz_square.canvas.height = this.bytebeat.viz_square.size
        /*for(var i=0;i<this.all_vizsquares.length;i++){
            this.all_vizsquares[i].change_function(this.bytebeat.data.f)
        }*/
        //this.bytebeat.data.vizsquare.draw(this.current_sample)

    }
}

// A bytebeat takes an ArtBlocks hash and calculates parameters for both the music and the visualizer.
class ByteBeat {
    constructor(hash, canvas) {
        //this.hash;
        /*const canvas = document.getElementsByTagName("canvas")[0]
        let size = Math.min(document.body.clientWidth,document.body.clientHeight)
        canvas.style.position = 'fixed'
        canvas.style.top = 0
        canvas.style.left = 0
        canvas.style.imageRendering = 'pixelated'
        canvas.style.width = `${size}px`
        canvas.style.height = `${size}px`
        canvas.style.backgroundColor = '#000'
        */
        this.hash = hash
        //this.canvas = React.createElement("canvas",{id: this.hash});
        this.canvas = canvas
        this.hashChunks = null;
        this.seeds = null;
        this.viz_square =null;

        // Generate the machine-readable parameters from the hash
        this.parameters = this.generateParameters(this.hash);

        // bytebeat object
        this.data = this.parameters["bytebeat"];
        console.log("bytebeat", this.bytebeat)

        this.getMetadata(this.hash)
        this.makeToken(this.canvas, this.hash, this.parameters)
        this.viz_square = this.makeVizSquare(this.parameters)

    }


    // This should be called whenever re-deriving the parameters from the hash. 
    // For example, when calling generateParameters in getMetadata
    resetSeeds(){
        // Pseudorandom chunks from the seed
        this.hashChunks = this.hash.match(/../g)
        this.hashChunks.shift() // pop off the '0x'
        this.seeds = this.hashChunks.map(h=>parseInt(h,16))
    }

    // Return a number 0 to 1 based on the next seed in the hash
    notRandom(){
        //console.log(seeds.length)
        return this.seeds.length > 0 ? this.seeds.pop()/256 : 0
    }

    // Return one item from the list, pseudorandomly
    choose(list){
        return list[Math.floor(this.notRandom()*list.length)]
    }


    // reset the seeds pointer, re-derive parameters from the hash 
    generateParameters(hash){
        this.resetSeeds();
        let hue = parseFloat(this.notRandom());
        console.log("hue",hue);
        let visual = this.choose(["bytes","bytes","bits","waveform","starry"]); // make bytes a bit more likely since it has the widest range of patterns
        // Choose based on the relative weight of each family 
        let family = this.choose(
            Array(8).fill("melodic").concat(
            Array(6).fill("heavy")).concat(
            Array(3).fill("wobbly")).concat(
            Array(3).fill("powerclimb")).concat(
            Array(3).fill("absurdities")).concat(
            Array(3).fill("permutations")).concat(
            Array(0).fill("crazy3"))
        )
        // pitch number (use this to derive sample rate and theoretically the root note)
        let pitch_number = Math.ceil(this.notRandom()*12);
        // sample rate
        let sr = Math.round(Math.pow(2,(pitch_number+-6)/12)*3951.07)
        // generate the bytebeat
        console.log(family)
        let bb = this.bytebeatFamilyFunction(family).bind(this)()

        // melodic and heavy melodic have chord progressions
        let matches = bb.match(/\,c\=b\%(\d)/);
        let progressions = (matches && matches.length>=2) ? parseInt(matches[1]) : 0
        // Let's just say powerclimb has infinity progression
        if(family=="powerclimb"){
            progressions = "Infinity";//"∞"
        }

        var bytebeat = this.new_bytebeat(bb,sr)

        return {
            "hue": hue,
            "visual": visual,
            "family": family,
            "bytebeat": bytebeat,
            "sr": sr,
            "progressions": progressions,
            "pitch_number": pitch_number
        }
    }


    // getMetadata resets the seeds pointer, re-derives the same parameters,
    // then returns nice human-readable parameters to be shown on artblocks website
    getMetadata(hash){
        let parameters = this.generateParameters(hash);

        // Hue > Tint
        let hue = parseInt(parameters["hue"] * 360);
        let tint = hue < 36 ? 'Fire' : ''
        tint = hue >= 36 && hue <= 63 ? 'Goldenrod' : tint
        tint = hue >= 64 && hue <= 133 ? 'Electric' : tint
        tint = hue === 73 ? 'Emerald Dragon' : tint
        tint = hue >= 134 && hue <= 171 ? 'Froggy' : tint
        tint = hue >= 172 && hue <= 181 ? 'Turquoise' : tint
        tint = hue >= 182 && hue <= 191 ? 'Sky' : tint
        tint = hue >= 192 && hue <= 211 ? 'Cobalt' : tint
        tint = hue >= 212 && hue <= 255 ? 'Royal' : tint
        tint = hue >= 256 && hue <= 281 ? 'Regal' : tint
        tint = hue >= 282 && hue <= 323 ? 'Neon' : tint
        tint = hue >= 324 && hue <= 333 ? 'Sexbomb' : tint
        tint = hue > 333 ? 'Lipstick' : tint

        console.log("hue", hue ,"tint", tint)

        // Visual Type
        let visual = parameters["visual"].capitalize();
        // Bytebeat code template
        let family = parameters["family"].capitalize().replace("_"," ")
        // update the names
        if(family=="Absurdities"){
            family="Inconsistent Absurdities"
        }else if(family=="Permutations"){
            family="Permutations"
        }else if(family=="Crazy3"){
            family="####"
        }else if(family=="Heavy"){
            family="Heavy Melodic"
        }else if(family=="Melodic"){
            family="Melodic"
        }else if(family=="Powerclimb"){
            family="Powerclimb"
        }else if(family=="Wobbly"){
            family="Wobbly"
        }
        // Sample rate
        let sr = parameters["sr"]
        // Progressions
        let progressions = parameters["progressions"]
        // Note Name
        // This is false actually
        //let note = ["F","F#","G","G#","A","A#","B","C","C#","D","D#","E","F"][parameters["pitch_number"]]

        let code = parameters["bytebeat"]["code"]
        let o = {
            tint: tint,
            visual: visual,
            family: family,
            sample_rate: sr,
            progressions: progressions,
            code: code
        }

        console.table(o)
        return o
    }

    random_hash() {
      let chars = "0123456789abcdef";
      let result = '0x';
      for (let i = 64; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
      return result;
    }


    // returns the function responsible for generating the bytebeat in that family
    bytebeatFamilyFunction(family){
        switch (family) {
            case "melodic":
                return this.make_melodic;
            case "heavy":
                return this.make_heavy;
            case "absurdities":
                return this.make_absurdities;
            case "permutations":
                return this.make_permutations;
            case "crazy3":
                return this.make_crazy3;
            case "wobbly":
                return this.make_wobbly;
            case "powerclimb":
                return this.make_powerclimb;
        }
    }

    make_melodic(){
        let r0 = this.choose([4,5,6,7,8,9])
        let r1 = this.choose([18,18,18,17,17,17,15,14])
        let r2 = this.choose(["c=b%2+1","c=b%3+1","c=b%3+1","c=b%4+1","c=b%5+1","c=b%6+1","c=b%24+1"])
        let r3 = this.choose([7,6,5,4])
        let r4 = this.choose([4,3,3,3,3,3,2])
        let r5 = this.choose([
            "(t*(a/2)/c&t>>10)|(t*a/c&t>>9)",
            "(t*(a/2)/c&t>>10)|(t*a/c&t>>9)"
            ])
        let r6 = this.choose([
            "|(t*(a*4/c)&t>>8)|(t*(a*5/c)&t>>"+r3+")|(t*(a*6/c)&t>>"+r4+")",
            "|(t*(a*4/c)&t>>8)|(t*(a*5/c)&t>>"+r3+")|(t*(a*6/c)&t>>"+r4+")",
            "|(t*(a*2/c)&t>>8)|(t*(a*3/c)&t>>"+r3+")|(t*(a*4/c)&t>>"+r4+")",
            "|(t*(a*5/c)&t>>8)|(t*(a*6/c)&t>>"+r3+")|(t*(a*7/c)&t>>"+r4+")"])
        let bb  = "a="+r0+","
        bb += "b=((t>>"+r1+")&0xFF),"
        bb += r2+","
        bb += r5
        bb += r6
        return bb
    }

    // lots of notes, carnival
    make_absurdities(){
        let r0 = this.choose([5,6,7,8,9,10,11,12,13])
        let r1 = this.choose([5,6,7,8,9,10,11,12,13])
        let r2 = this.choose([5,6,7,8,9,10,11,12,13])
        let r3 = this.choose([5,6,7,8,9,10,11,12,13])
        let r4 = this.choose([69,9,4,5,6])
        let bb = "t*(0x"+r4+"+(0xABCDEF&t>>10))*(("+r0+"&t>>"+r1+")|("+r1+"&t>>"+r2+")|("+r2+"&t>>"+r3+")|("+r3+"&t>>"+r0+"))"
        return bb;
    }

    // pretty crazy, kind of annoying
    make_permutations(){
        let r0 = this.choose([1,2]);
        let r1 = this.choose([1,2,10,20,40,50]);
        let bb = "a=0.5,b="+r0+",c="+r1+",(t/a*((-c*(t/a|t/a*b>>5)/4)>>7))"
        return bb;
    }

    make_crazy3(){
        let r0 = this.choose([1,2,3,4,5,6,7,8,12,24])
        let r1 = this.choose([1,2,3])
        let r2 = this.choose(["(c/8<<8)|(c/4<<4)|(c/2<<3)","(c/6<<8)|(c/5<<7)|(c/4<<4)"])
        let bb = "a="+r0+",b=a/"+r1+",t=t*a,c=(-(t>>b|t>>10)>>4)/4,t*("+r2+")"
        return bb;
    }

    make_powerclimb(){
        let r0 = this.choose([1.6,1.7,1.8])
        let r1 = this.choose([0.05,0.08,0.1,0.15,0.18,0.2])
        let r2= this.choose([0,1])
        let bb ="a=0xFF,b="+r0+",c="+r1+",\
    ((1*(pow(t,b+c*0))>>14)&a)^\
    ((1*(pow(t,b+c*1))>>14)&a)^\
    ((1*(pow(t,b+c*2))>>14)&a)^\
    ((1*(pow(t,b+c*3))>>14)&a*"+r2+")"
        return bb
    }

    make_heavy(){
        let r1 = this.choose([17,17,16,16,15,14])
        let r2 = this.choose(["c=b%2+1","c=b%3+1","c=b%3+2","c=b%3+3","c=b%3+4","c=b%4+1","c=b%6+1"])
        let r3 = this.choose([1,2,3,4,5,6,7,8,9,11])
        let r4 = this.choose([1,2,3])
        let r5 = this.choose([8,9])
        let bb ="b=((t>>("+r1+"))&0xFF),"+r2+",((t>>7)|(t>>"+r5+")|(t*"+r3+"))*(t/c<<"+r4+")";
        return bb
    }

    make_wobbly(){
        let r1 = this.choose([2,3,4,5])
        let r2 = this.choose([1,8,16,32,42,64,69,99])
        let bb ="a="+r1+",f="+r2+",b=(((t>>14)&0xFE)+1+f)%0xFE,d=1/4,((t*a*b*(t*a>>(t*a*d>>10)%16)))"
        return bb;
    }

    new_bytebeat(code, sr){
        let original_code = code;
        code = replace_all(code, "pow","Math.pow");
        code = replace_all(code, "sqrt","Math.sqrt");
        let f = this.make_sample_function(code);
            return {
            f: f,
            sr: sr,
            code: code,
            original_code: original_code
        }
    }

    make_sample_function(bytebeat_code){
        try { 
            var f = new Function('"use strict"; return function(t){ \
                var a=0,b=0,c=0,d=0,e=0,f=0;\
                return '+bytebeat_code+';};');
            return f();
        }catch(e){
            console.error("FAILED FUNCTION");
            return;
        }
    }

    makeVizSquare(parameters){
        var visual = parameters["visual"]
        var hue = parameters["hue"]

        let bytebeat = parameters["bytebeat"];
        console.log(bytebeat, bytebeat.f(0));

        if(visual=="bytes"){
            var size = this.choose([64,128,256])
            var slow_factor = this.choose([1])
            var rgb = hsvToRgb(hue,1,1);
            return new VizSquare(this.canvas, "_",size,slow_factor,visual,bytebeat.f,{
                "r": rgb[0], "g": rgb[1], "b": rgb[2], "reflect": false});
        }else if(visual=="bits"){
            var size = this.choose([64,128])
            var slow_factor = this.choose([1])
            var rgb = hsvToRgb(hue,1,1);
            return new VizSquare(this.canvas, "_",size,slow_factor,visual,bytebeat.f,{
                "r": rgb[0], "g": rgb[1], "b": rgb[2]
            });
        }else if(visual=="waveform"){
            var size = this.choose([128,256])
            var thickness = this.choose([1,2])
            var slow_factor = this.choose([1])
            var rgb = hsvToRgb(hue,1,1);
            return new VizSquare(this.canvas, "_",size,slow_factor,visual,bytebeat.f,{
                "thickness": thickness, "color": "rgb("+rgb[0]+","+rgb[1]+","+rgb[2]+")"
            });
        }else if(visual=="starry"){
            var size = this.choose([128])
            var thickness = this.choose([1,2])
            var ppc = this.choose([2,4])
            var slow_factor = this.choose([1])
            var rgb = hsvToRgb(hue,1,1);
            return new VizSquare(this.canvas, "_",size,slow_factor,visual,bytebeat.f,{
                "thickness": thickness, "ppc": ppc, "color": "rgb("+rgb[0]+","+rgb[1]+","+rgb[2]+")"
            });
        }
    }

    makeToken(canvas,hash,parameters){        
        
        //let size = Math.min(document.body.clientWidth,document.body.clientHeight)
        let size = 256
        console.log("canvas", canvas)
        //canvas.width = size
        //canvas.height = size
        let scale = 1
        
        let vizSquare = this.makeVizSquare(parameters)
        vizSquare.draw(0)

        // find the best density across a lot of samples
        let maxDensity = 0
        let maxSample = 0
        for(let i=0;i<100000;i+=1000){
            vizSquare.draw(i)
            let currDensity = getDensity(vizSquare.canvas)
            if(currDensity > maxDensity){
                maxDensity = currDensity
                maxSample = i
                //console.log('DENSITY:',getDensity(vizSquare.canvas))
                //console.log('Current Sample:',i) 
            } 
        }
        vizSquare.draw(maxSample)
        console.log(`FINAL DENSITY: ${getDensity(vizSquare.canvas)} at ${maxSample}`)
        return vizSquare;
    }

    render() {
        return (
            this.canvas
        );
    }
}




// Add event listeners

/*
window.addEventListener('load', init, false)
window.addEventListener('keydown',()=>{playpause()},false)
window.addEventListener('mousedown',()=>{playpause()},false)
window.addEventListener('touchstart',()=>{playpause()},false)
*/





// Object which represents the visualization of the bytebeat
// The page could theoretically have several
class VizSquare {
    constructor(canvas, name, size, slow_factor, visual, f, params){
        this.name = name;
        this.size = size;
        this.visual = visual;
        this.params = params;
        // internal canvas
        this.canvas = canvas
        
        //this.canvas = document.getElementById(canvas)
        //this.canvas.id = "canvas_" + name
        this.canvas.width = size;
        this.canvas.height = size;
        //document.body.appendChild(this.canvas)
        this.ctx = canvas.getContext("2d");
        console.log("canvas", canvas, this.ctx)

        this.f = f;

        if(visual == "bytes" || visual == "bits"){
            this.imageData = this.ctx.createImageData(this.size, this.size);
            this.buffer = new ArrayBuffer(this.imageData.data.length);
            this.byteArray = new Uint8ClampedArray(this.buffer);
            this.intArray = new Uint32Array(this.buffer);
        }
        this.slow_factor = slow_factor;
        this.last_draw_t = -1;

    }
    // call this on every vizsquare when changing the currently playing bytebeat
    change_function(f){
        this.f = f;
    }
    draw(current_sample){
        //console.log(current_sample, this.ctx)
        var current_draw_t = Math.floor(current_sample/this.size/this.slow_factor)*this.size*this.slow_factor;
        var delta_t = current_draw_t - this.last_draw_t
        if(delta_t==0){
            return;
        }
        // remember for next time
        this.last_draw_t = current_draw_t;

        if(this.visual == "bytes"){
            draw_bytes(this.ctx, this.imageData, this.byteArray, this.intArray, this.f, this.size, this.size, current_draw_t, delta_t, 
                this.params["r"], this.params["g"], this.params["b"]);
        }else if(this.visual == "bits"){
            draw_bits(this.ctx, this.imageData, this.byteArray, this.intArray, this.f, this.size, this.size, current_draw_t, this.params["r"], this.params["g"], this.params["b"]);
        }else if(this.visual == "waveform"){
            draw_waveform(this.ctx, this.f, this.size, this.size, current_draw_t, 
                this.params["thickness"], this.params["color"])
        }else if(this.visual == "starry"){
            draw_starry(this.ctx, this.f, this.size, this.size, current_draw_t, 
                this.params["ppc"], this.params["thickness"], this.params["color"]);
        }
    }
}


String.prototype.capitalize = function() {
  return this.charAt(0).toUpperCase() + this.slice(1)
}


window.requestAnimFrame = (function(){
return  window.requestAnimationFrame       || 
  window.webkitRequestAnimationFrame || 
  window.mozRequestAnimationFrame    || 
  window.oRequestAnimationFrame      || 
  window.msRequestAnimationFrame     || 
  function( callback ){
  window.setTimeout(callback, 1000 / 60);
};
})();


function getDensity(canvas){
    let c = canvas.getContext('2d')
    let size = canvas.width
    let imageData = c.getImageData(0,0,size,size)


    return imageData.data.reduce((p,c)=>{ return c+p },0)/Math.pow(size,2) ///imageData.data.length },0)
}

/////////////
// BYTEBEAT GENERATING FUNCTIONS
/////////


//////
/// DRAWING FUNCTIONS
////

function draw_bytes(ctx, imageData, byteArray, intArray, f, w, h, current_draw_t, delta_t, r,g,b){
    // draw the byte structure
      for(var i=0;i<intArray.length;i++){
          var pos = samplePos2graph(i, w, h);

          if(i<delta_t && delta_t<intArray.length){
              // don't recalculate, just pull from the later in the array
              intArray[pos] = intArray[samplePos2graph(i+delta_t, h)]
          }else{
              // new samples
                var sample = i + current_draw_t;
                // Calculate the 8bit quantized amplitude value
                let alpha = f(sample)&255;
                // Convert amplitude to brightness
                let brightness = Math.abs(alpha-128) * 2
            //rgb = hsvToRgb(hue,1,1-brightness/256.0);

            intArray[pos] = 
              (brightness   << 24) |    // alpha
              (b << 16) |    // blue
              (g <<  8) |    // green
               r;            // red
            
            }
        }

        // draw the byte data on the byte canvas
        imageData.data.set(byteArray);
        ctx.putImageData(imageData,0,0);

}

function draw_bits(ctx, imageData, byteArray, intArray, f, w, h, current_draw_t, r, g, b){
        // draw the BITS structure
      for(var x=0;x<w;x++){
          // new samples
            var t = x + current_draw_t;
            // Calculate the 8bxt quantxzed amplxtude value
            let amplitude = f(t)&255;

            for (var y=0;y<h;y++){
                let bit = Math.floor(y/h*8);
                let bit_value = (amplitude>>bit)%2 
                let alpha = bit_value * 255
                alpha = Math.floor(alpha )
            intArray[y + x*h] = 
              (alpha   << 24) |    // alpha
              (b << 16) |    // blue
              (g <<  8) |    // green
               r;            // red
        }
        }
        // draw the starry data on the starry canvas
        imageData.data.set(byteArray);
        ctx.putImageData(imageData,0,0);
}

function draw_waveform(ctx, f, w, h, current_draw_t, thickness, color){
        ctx.clearRect(0, 0, w, h);
        ctx.beginPath();
        for(var x=0;x<w;x++){
          // new samples
            var t = x + current_draw_t;
            // Calculate the 8bxt quantxzed amplxtude value
            let y = f(t)&255;
            if(x==0){
                ctx.moveTo(x, y);
            }else{
                ctx.lineTo(x,y);
            }
        }
        ctx.lineWidth=thickness;
        ctx.strokeStyle = color; 
        ctx.stroke();
}


// ppc points per column
function draw_starry(ctx, f, w, h, current_draw_t, ppc, thickness, color){
    ctx.clearRect(0, 0, w, h);
    ctx.beginPath();
    for(var x=0;x<w;x++){
        for(var j=0;j<ppc;j++){
            // new samples
            var t = x*ppc+j + current_draw_t ;

            // Calculate the 8bxt quantxzed amplxtude value
            let y = f(t)&255;
            if(x==0){
                ctx.moveTo(x, y);
            }else{
                ctx.moveTo(x, y);
                ctx.fillRect(x,y,thickness, thickness); 
            }
        }
    }
    ctx.strokeStyle = color;
    ctx.fillStyle = color;
    ctx.stroke();
}


    

/////// 
// HELPER FUNCTIONS
////

// replace all instances of search with replace in string
function replace_all(string, search, replace) {
    return string.split(search).join(replace);
}
    
// convert hsv to rgb color
function hsvToRgb(h, s, v) {
  var r=0, g=0, b=0;
  var i = Math.floor(h * 6);
  var f = h * 6 - i;
  var p = v * (1 - s);
  var q = v * (1 - f * s);
  var t = v * (1 - (1 - f) * s);
  switch (i % 6) {
    case 0: r = v; g = t; b = p; break;
    case 1: r = q; g = v; b = p; break;
    case 2: r = p; g = v; b = t; break;
    case 3: r = p; g = q; b = v; break;
    case 4: r = t; g = p; b = v; break;
    case 5: r = v; g = p; b = q; break;
  }
  return [ r * 255, g * 255, b * 255 ];
}

function samplePos2graph(i, w, h){
    return ( w*(i%h)+Math.floor(i/h) );
}

function graphPos2sample(pos, h){
    return pos.x*h+pos.y;
}   

/*
module.exports = {
    Bytebeat: Bytebeat,
    ByteBeatEngine: ByteBeatEngine
}*/
export {
    ByteBeat, ByteBeatEngine
}